import {CustomerResponseBodyV2} from '../types';

export const physicalCustomerResponseMock: CustomerResponseBodyV2 = {
  id: '7add24d5-615b-42ca-84d3-1cdd361cd4cc',
  discriminator: 'NATURAL_PERSON',
  source: null,
  foundingPerson: {
    id: '5ac4d489-4105-43fb-b026-c18d7ea3b989',
    firstName: 'Jan',
    lastName: 'Ehrlich',
    middleName: null,
    titleBefore: 'ing.',
    titleAfter: null,
    genderKey: 'GENDER_MALE',
    roles: null,
    citizenshipCode: 'CZE',
    birthdate: '1992-12-16',
    personalIdentifier: '9212162971',
    preferredLanguage: null,
    phoneNumbers: [
      {
        type: 'work',
        countryCode: 'CZE',
        prefix: '+420',
        number: '739564329',
      },
    ],
    emails: [
      {
        type: 'work',
        email: 'jan.ehrlich@carvago.com',
      },
    ],
    identityCards: [
      {
        id: '80e9cc6e-4291-4d02-a093-4aecadbeeaa6',
        type: 'ID_PASSPORT',
        cardNumber: '12313123',
        issuedOn: null,
        validUntil: null,
        issuer: null,
        issuedInCountryCode: null,
        note: null,
      },
    ],
    permanentAddress: {
      id: 'c4fd443c-4107-4f29-8ab9-8328e1ea3814',
      address: {
        street: 'Karla Marxe',
        descriptiveNumber: '731',
        orientationNumber: '4',
        city: 'Most',
        zip: '43401',
        addressComplement: null,
        country: 'CZE',
        prefix: null,
        district: 'Most',
        state: 'Ústecký kraj',
        postal: null,
        coordinates: null,
        externalAddressId: null,
      },
      type: 'Permanent address',
      invalid: false,
    },
  },
  businessInfo: null,
  contacts: [
    {
      id: '58559a00-e1de-452a-b2d6-1e987ffa0e62',
      firstName: 'David',
      lastName: 'Jeřábek',
      middleName: null,
      titleBefore: 'PhDr',
      titleAfter: null,
      genderKey: 'GENDER_OTHER',
      roles: 'manager',
      citizenshipCode: 'CZE',
      birthdate: null,
      personalIdentifier: null,
      preferredLanguage: null,
      phoneNumbers: [
        {
          type: 'work',
          countryCode: 'CZE',
          prefix: '+420',
          number: '738132211',
        },
      ],
      emails: [
        {
          type: null,
          email: 'david.jerabek@carvago.com',
        },
      ],
      identityCards: [],
      permanentAddress: {
        id: 'fcc2c672-c8ab-4fb8-8ce4-286ecebb23d0',
        address: {
          street: 'Kersko',
          descriptiveNumber: null,
          orientationNumber: null,
          city: 'Praha',
          zip: '198000',
          addressComplement: '40',
          country: 'CZE',
          prefix: null,
          district: null,
          state: null,
          postal: null,
          coordinates: null,
          externalAddressId: null,
        },
        type: '',
        invalid: null,
      },
    },
  ],
  primaryContactId: '58559a00-e1de-452a-b2d6-1e987ffa0e62',
  persons: [
    {
      id: '58559a00-e1de-452a-b2d6-1e987ffa0e62',
      firstName: 'David',
      lastName: 'Jeřábek',
      middleName: null,
      titleBefore: 'PhDr',
      titleAfter: null,
      genderKey: 'GENDER_OTHER',
      roles: 'manager',
      citizenshipCode: 'CZE',
      birthdate: null,
      personalIdentifier: null,
      preferredLanguage: null,
      phoneNumbers: [
        {
          type: 'work',
          countryCode: 'CZE',
          prefix: '+420',
          number: '738132211',
        },
      ],
      emails: [
        {
          type: null,
          email: 'david.jerabek@carvago.com',
        },
      ],
      identityCards: [],
      permanentAddress: {
        id: 'fcc2c672-c8ab-4fb8-8ce4-286ecebb23d0',
        address: {
          street: 'Kersko',
          descriptiveNumber: null,
          orientationNumber: null,
          city: 'Praha',
          zip: '198000',
          addressComplement: '40',
          country: 'CZE',
          prefix: null,
          district: null,
          state: null,
          postal: null,
          coordinates: null,
          externalAddressId: null,
        },
        type: '',
        invalid: null,
      },
    },
    {
      id: '5ac4d489-4105-43fb-b026-c18d7ea3b989',
      firstName: 'Jan',
      lastName: 'Ehrlich',
      middleName: null,
      titleBefore: 'ing.',
      titleAfter: null,
      genderKey: 'GENDER_MALE',
      roles: null,
      citizenshipCode: 'CZE',
      birthdate: '1992-12-16',
      personalIdentifier: '9212162971',
      preferredLanguage: null,
      phoneNumbers: [
        {
          type: 'work',
          countryCode: 'CZE',
          prefix: '+420',
          number: '739564329',
        },
      ],
      emails: [
        {
          type: 'work',
          email: 'jan.ehrlich@carvago.com',
        },
      ],
      identityCards: [
        {
          id: '80e9cc6e-4291-4d02-a093-4aecadbeeaa6',
          type: 'ID_PASSPORT',
          cardNumber: '12313123',
          issuedOn: null,
          validUntil: null,
          issuer: null,
          issuedInCountryCode: null,
          note: null,
        },
      ],
      permanentAddress: {
        id: 'c4fd443c-4107-4f29-8ab9-8328e1ea3814',
        address: {
          street: 'Karla Marxe',
          descriptiveNumber: '731',
          orientationNumber: '4',
          city: 'Most',
          zip: '43401',
          addressComplement: null,
          country: 'CZE',
          prefix: null,
          district: 'Most',
          state: 'Ústecký kraj',
          postal: null,
          coordinates: null,
          externalAddressId: null,
        },
        type: 'Permanent address',
        invalid: false,
      },
    },
  ],
  contractInformation: [
    {
      id: '08efdc32-6488-49ed-9a32-fcb050a95a5f',
      permanent: false,
      legalForm: 'SELF_EMPLOYED',
      person: null,
      isDeleted: false,
      businessInfo: {
        id: '7a191869-2ad6-4235-a720-01141df52469',
        businessInfo: {
          countryOfRegistrationCode: 'CZE',
          registrationNumber: '07202644',
          vatNumber: 'CZ9212162971',
          tradeName: 'Jan Ehrlich',
          fileNumber: 'Zapsán v živnostenském rejstříku příslušného úřadu: Magistrát města Mostu',
        },
        address: {
          id: 'c4fd443c-4107-4f29-8ab9-8328e1ea3814',
          address: {
            street: 'Karla Marxe',
            descriptiveNumber: '731',
            orientationNumber: '4',
            city: 'Most',
            zip: '43401',
            addressComplement: null,
            country: 'CZE',
            prefix: null,
            district: 'Most',
            state: 'Ústecký kraj',
            postal: null,
            coordinates: null,
            externalAddressId: null,
          },
          type: 'Permanent address',
          invalid: false,
        },
      },
      bankAccounts: [],
      customFieldsPayload: [],
    },
    {
      id: '4bbd67b1-da13-49f7-8a11-f03d68a66654',
      permanent: false,
      legalForm: 'NATURAL_PERSON',
      isDeleted: false,
      person: {
        id: '5ac4d489-4105-43fb-b026-c18d7ea3b989',
        firstName: 'Jan',
        lastName: 'Ehrlich',
        middleName: null,
        titleBefore: 'ing.',
        titleAfter: null,
        genderKey: 'GENDER_MALE',
        roles: null,
        citizenshipCode: 'CZE',
        birthdate: '1992-12-16',
        personalIdentifier: '9212162971',
        preferredLanguage: null,
        phoneNumbers: [
          {
            type: 'work',
            countryCode: 'CZE',
            prefix: '+420',
            number: '739564329',
          },
        ],
        emails: [
          {
            type: 'work',
            email: 'jan.ehrlich@carvago.com',
          },
        ],
        identityCards: [
          {
            id: '80e9cc6e-4291-4d02-a093-4aecadbeeaa6',
            type: 'ID_PASSPORT',
            cardNumber: '12313123',
            issuedOn: null,
            validUntil: null,
            issuer: null,
            issuedInCountryCode: null,
            note: null,
          },
        ],
        permanentAddress: {
          id: 'c4fd443c-4107-4f29-8ab9-8328e1ea3814',
          address: {
            street: 'Karla Marxe',
            descriptiveNumber: '731',
            orientationNumber: '4',
            city: 'Most',
            zip: '43401',
            addressComplement: null,
            country: 'CZE',
            prefix: null,
            district: 'Most',
            state: 'Ústecký kraj',
            postal: null,
            coordinates: null,
            externalAddressId: null,
          },
          type: 'Permanent address',
          invalid: false,
        },
      },
      businessInfo: null,
      bankAccounts: [
        {
          id: '0a8cb590-ba53-4fdb-86c5-03916f8ae500',
          name: null,
          countryCode: 'CZE',
          ownerName: null,
          swiftBic: null,
          currency: null,
          number: '72121611',
          bankCode: '5500',
          iban: null,
          isDeleted: false,
        },
      ],
      customFieldsPayload: [],
    },
    {
      id: '7add24d5-615b-42ca-84d3-1cdd361cd4cc',
      permanent: true,
      legalForm: 'NATURAL_PERSON',
      isDeleted: false,
      person: {
        id: '5ac4d489-4105-43fb-b026-c18d7ea3b989',
        firstName: 'Jan',
        lastName: 'Ehrlich',
        middleName: null,
        titleBefore: 'ing.',
        titleAfter: null,
        genderKey: 'GENDER_MALE',
        roles: null,
        citizenshipCode: 'CZE',
        birthdate: '1992-12-16',
        personalIdentifier: '9212162971',
        preferredLanguage: null,
        phoneNumbers: [
          {
            type: 'work',
            countryCode: 'CZE',
            prefix: '+420',
            number: '739564329',
          },
        ],
        emails: [
          {
            type: 'work',
            email: 'jan.ehrlich@carvago.com',
          },
        ],
        identityCards: [
          {
            id: '80e9cc6e-4291-4d02-a093-4aecadbeeaa6',
            type: 'ID_PASSPORT',
            cardNumber: '12313123',
            issuedOn: null,
            validUntil: null,
            issuer: null,
            issuedInCountryCode: null,
            note: null,
          },
        ],
        permanentAddress: {
          id: 'c4fd443c-4107-4f29-8ab9-8328e1ea3814',
          address: {
            street: 'Karla Marxe',
            descriptiveNumber: '731',
            orientationNumber: '4',
            city: 'Most',
            zip: '43401',
            addressComplement: null,
            country: 'CZE',
            prefix: null,
            district: 'Most',
            state: 'Ústecký kraj',
            postal: null,
            coordinates: null,
            externalAddressId: null,
          },
          type: 'Permanent address',
          invalid: false,
        },
      },
      businessInfo: null,
      bankAccounts: [
        {
          id: '6a0b6f52-e2dc-42ad-b321-508d50033a72',
          name: 'Ahoj',
          countryCode: 'CZE',
          ownerName: null,
          swiftBic: 'fgh',
          currency: 'CZK',
          number: 'awfsef',
          bankCode: '0600',
          iban: 'fgh',
          isDeleted: false,
        },
      ],
      customFieldsPayload: [],
    },
    {
      id: 'c009a270-24d5-4332-b4ef-b7fc4d5e47c5',
      permanent: false,
      legalForm: 'SELF_EMPLOYED',
      isDeleted: false,
      person: null,
      businessInfo: {
        id: '8a4112cd-9fc1-4dac-abcf-dc2ef09fe359',
        businessInfo: {
          countryOfRegistrationCode: 'CZE',
          registrationNumber: '07202644',
          vatNumber: 'CZ9212162971',
          tradeName: 'Jan Ehrlich',
          fileNumber: 'Zapsán v živnostenském rejstříku příslušného úřadu: Magistrát města Mostu',
        },
        address: {
          id: 'c4fd443c-4107-4f29-8ab9-8328e1ea3814',
          address: {
            street: 'Karla Marxe',
            descriptiveNumber: '731',
            orientationNumber: '4',
            city: 'Most',
            zip: '43401',
            addressComplement: null,
            country: 'CZE',
            prefix: null,
            district: 'Most',
            state: 'Ústecký kraj',
            postal: null,
            coordinates: null,
            externalAddressId: null,
          },
          type: 'Permanent address',
          invalid: false,
        },
      },
      bankAccounts: [],
      customFieldsPayload: [],
    },
  ],
  addresses: [
    {
      id: 'fcc2c672-c8ab-4fb8-8ce4-286ecebb23d0',
      address: {
        street: 'Kersko',
        descriptiveNumber: null,
        orientationNumber: null,
        city: 'Praha',
        zip: '198000',
        addressComplement: '40',
        country: 'CZE',
        prefix: null,
        district: null,
        state: null,
        postal: null,
        coordinates: null,
        externalAddressId: null,
      },
      type: '',
      invalid: null,
    },
    {
      id: 'b3040e47-adc4-4672-9daf-23c2b195a40b',
      address: {
        street: 'Karla Marxe 731/4',
        descriptiveNumber: null,
        orientationNumber: null,
        city: 'Most',
        zip: '43401',
        addressComplement: null,
        country: 'CZE',
        prefix: null,
        district: null,
        state: '',
        postal: null,
        coordinates: null,
        externalAddressId: null,
      },
      type: 'Permanent address',
      invalid: null,
    },
    {
      id: 'c4fd443c-4107-4f29-8ab9-8328e1ea3814',
      address: {
        street: 'Karla Marxe',
        descriptiveNumber: '731',
        orientationNumber: '4',
        city: 'Most',
        zip: '43401',
        addressComplement: null,
        country: 'CZE',
        prefix: null,
        district: 'Most',
        state: 'Ústecký kraj',
        postal: null,
        coordinates: null,
        externalAddressId: null,
      },
      type: 'Permanent address',
      invalid: false,
    },
  ],
  selfEmployed: true,
  selfEmployedBusinessAddress: {
    id: 'c4fd443c-4107-4f29-8ab9-8328e1ea3814',
    address: {
      street: 'Karla Marxe',
      descriptiveNumber: '731',
      orientationNumber: '4',
      city: 'Most',
      zip: '43401',
      addressComplement: null,
      country: 'CZE',
      prefix: null,
      district: 'Most',
      state: 'Ústecký kraj',
      postal: null,
      coordinates: null,
      externalAddressId: null,
    },
    type: 'Permanent address',
    invalid: false,
  },
  selfEmployedBusinessInfoData: {
    countryOfRegistrationCode: 'CZE',
    registrationNumber: '07202644',
    vatNumber: 'CZ9212162971',
    tradeName: 'Jan Ehrlich',
    fileNumber: 'Zapsán v živnostenském rejstříku příslušného úřadu: Magistrát města Mostu',
  },
  publicId: '7add24d5-615b-42ca-84d3-1cdd361cd4cc',
  institutions: [],
  customerGroups: [],
  abroadSale: null,
  preferredLocale: null,
};
